
import React, { useEffect, useRef } from "react";
import { Chart } from "chart.js";
import { Box } from "@mui/material";

const AnalyticsChart = ({ type, data, options, height = 250 }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartRef.current) {
      // Destroy existing chart
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }

      // Create new chart
      chartInstance.current = new Chart(chartRef.current, {
        type,
        data,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          ...options,
        },
      });
    }

    // Cleanup on unmount
    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [type, data, options]);

  return (
    <Box sx={{ height, position: "relative" }}>
      <canvas ref={chartRef} />
    </Box>
  );
};

export default React.memo(AnalyticsChart);
